var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "overlay-close-btn",
      class: _vm.bemFacets,
      on: { click: _vm.onClose }
    },
    [
      _vm._t("default", [
        _c("base-icon", {
          staticClass: "overlay-close-btn--icon",
          attrs: { symbol: "close", size: "small" }
        })
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05c2d7d1", { render: render, staticRenderFns: staticRenderFns })
  }
}